import React from 'react';
import { Drawer, List, ListItem, ListItemText, ListItemIcon, Divider, Typography, Box } from '@mui/material';
import HomeIcon from '@mui/icons-material/Home';
import InventoryIcon from '@mui/icons-material/Inventory';
import AssignmentIcon from '@mui/icons-material/Assignment';
import LogoutIcon from '@mui/icons-material/Logout';
import { Link, useNavigate } from 'react-router-dom';

const Sidebar = ({ open, toggleSidebar, user, setUser }) => {
  const navigate = useNavigate();

  const handleLogout = () => {
    setUser(null);
    localStorage.removeItem('user');
    toggleSidebar();
    navigate('/login');
  };

  return (
    <Drawer anchor="left" open={open} onClose={toggleSidebar}>
      <Box sx={{ width: 250 }}>
        {user && (
          <>
            <Box sx={{ p: 2, bgcolor: 'primary.main', color: 'white', textAlign: 'center' }}>
              <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                {user.nombre}
              </Typography>
              <Typography variant="body2">{user.email}</Typography>
            </Box>

            <List>
              <ListItem button component={Link} to="/dashboard" onClick={toggleSidebar}>
                <ListItemIcon>
                  <HomeIcon />
                </ListItemIcon>
                <ListItemText primary="Inicio" />
              </ListItem>

              <ListItem button onClick={() => { navigate('/missuministros'); toggleSidebar(); }}>
                <ListItemIcon>
                  <InventoryIcon />
                </ListItemIcon>
                <ListItemText primary="Mis suministros" />
              </ListItem>



              <Divider sx={{ my: 1 }} />

              <ListItem button onClick={handleLogout}>
                <ListItemIcon>
                  <LogoutIcon />
                </ListItemIcon>
                <ListItemText primary="Cerrar sesión" />
              </ListItem>
            </List>
          </>
        )}
      </Box>
    </Drawer>
  );
};

export default Sidebar;
